<template>
  <div
    class="gw_table_head_cell"
    :style="item.cssStyle"
    v-bind="item.props || {}"
    :class="[
      item.cssClass || '',
      { gw_table_head_cell_sortable: item.sortKey },
      { gw_table_head_cell_sorted: isSorted },
    ]"
    :data-tst="`th_${tstPrefix}`"
    @click="
      e => {
        $emit('click', item)
        $emit('click:event', e, item)
      }
    "
  >
    <!-- ${item.minWidth ? `--min-width-th: ${item.minWidth};` : ''} -->
    <div class="gw_table_head_cell_content">
      <slot>
        <span
          :title="item.name"
          v-html="item.name"
        ></span>
      </slot>
    </div>
    <slot name="sort_icon">
      <i
        v-if="item.sortKey"
        class="gw_table_head_cell_sort_icon mdi transition_03 mdi-menu-down"
        :class="{ rotated_180_before: sortConf.sortOrder === 'asc' }"
      />
    </slot>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'TableHead',
  mixins: [],
  props: {
    item: { default: () => ({}) },
    tstPrefix: String,
    sortConf: {
      default: () => ({
        // sortOrder: 'desc',
        // sortKey: 'name',
      }),
    },
  },
  emits: ['click', 'click:event'],
  data() {
    return {}
  },

  computed: {
    isSorted() {
      // console.log(this.item.sortKey, this.sortConf.sortKey, this.sortConf.sortOrder)
      // console.log(this.item, this.item.sortKey, this.sortConf.sortKey)
      return this.item.sortKey && this.item.sortKey === this.sortConf.sortKey
    },
  },
}
</script>

<style lang="scss" scoped>
// .gw_table_head_cell {
// box-shadow: 0px 0px 1px red;

// display: flex;
// align-items: center;
// position: relative;
// flex: 1;

// --max-width-th: unset;
// --height-th: 2.5rem;
// --th-content: 0 1rem;
// --padding-th: 0 2rem 0 1rem;
// --padding-sortable-th: 0 2rem 0 1rem;

// --clr-back-th: transparent;
// --clr-back-th-sortable-hover: var(--clr-black-2);
// --clr-back-th-sortable-sorted: var(--clr-black-2);

// --inset-sort-icon: auto 0.5rem auto auto;
// --opacity-sort-icon: 0;
// --opacity-sort-icon-hover: 1;
// --opacity-sort-icon-active: 1;

// background: var(--clr-back-th);
// height: var(--height-th);
// max-width: var(--max-width-th);

// &_content {
//   padding: var(--padding-th);
// }
// &_sortable {
//   --padding-th: var(--padding-sortable-th);
// }
// &_sort_icon {
//   position: absolute;
//   transition: opracity 0.22s;
//   opacity: var(--opacity-sort-icon);
//   inset: var(--inset-sort-icon);
// }
// &_sorted {
//   --clr-back-th: var(--clr-back-th-sortable-sorted);
//   .gw_table_head_cell_sort_icon {
//     --opacity-sort-icon: var(--opacity-sort-icon-active);
//   }
// }
// }

// @media (hover: hover) and (pointer: fine) {
//   .gw_table_head_cell {
//     &_sortable {
//       &:hover {
//         cursor: pointer;
//         --clr-back-th: var(--clr-back-th-sortable-hover);
//         --opacity-sort-icon: var(--opacity-sort-icon-hover);
//       }
//     }
//   }
// }
</style>
